import { AwardData, AwardGroupData, AwardPermissionResponse } from './cxone-award.model';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { Injectable } from '@angular/core';
import { SolToastrService } from "@niceltd/sol/toastr";

@Injectable({
    providedIn: "root",
})
export class CxoneAwardService {
    private BASE_URL_MANUAL_AWARDS: string =
        "/api/v2/gamification/manualawards";
    private BASE_URL_AWARDS: string = "/api/v2/gamification/awards";

    constructor(private cvApiService: CVApiService,
        private toastrManager: SolToastrService,
        private cvLocalizationService: CVLocalizationService,
        private cvConfigurationService: CvConfigurationService
    ) {}

    async giveAward(ruleID: number, groupData: AwardGroupData, isFromDashboard: boolean = false, isCxOne: boolean = false): Promise<object> {
        try {
            const url = `${this.BASE_URL_MANUAL_AWARDS}/${ruleID}/groupId/${groupData.groupID}/groupLevel/${groupData.groupLevel}/isFromDashboard/${isFromDashboard}/isCxOne/${isCxOne}`;
            const response = await this.cvApiService.post<object>(url, {});
            if (response.status_code !== 200) {
                throw response;
            } else {
                if (isCxOne) {
                    const messageToaster = this.cvLocalizationService.getCachedText("Manual_Awards", "Toast_Confirmation_Message", "Awarded successfully.");
                    this.toastrManager.showToaster('success', messageToaster);
                }

                return response.data;
            }
        } catch (error) {
            console.error("Failed to give award");
            throw error;
        }
    }

    async loadAvailableAwards(moduleKey: string, groupData: AwardGroupData, abort?: Promise<void>): Promise<AwardData> {
        if (!groupData) {
            throw new Error("Group data is required");
        }
        try {
            const { groupID, groupLevel } = groupData;
            let renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const url = `${this.BASE_URL_AWARDS}/groupid/${groupID}/grouplevel/${groupLevel}?isCXone=${this.cvConfigurationService.isCxOne}`;
            const response = await this.cvApiService.get<AwardData>(url, renderEndpoint, abort);
            if (response.status_code !== 200)
                throw response;
            else
                return response.data;
        } catch (error) {
            console.error("Failed to load available awards");
            throw error;
        }

    }

    async getAwardPermission(): Promise<AwardPermissionResponse> {
        try {
            const url = `${this.BASE_URL_MANUAL_AWARDS}/permission`;
            const response = await this.cvApiService.get<AwardPermissionResponse>(url);
            if (response.status_code !== 200)
                throw response;
            else
                return response.data;
        } catch (error) {
            console.error("Failed to get award permission");
            throw error;
        }
    }
}
